// Ekran 13'e özgü sunum yardımcıları.
//
// Neden lib/trFormat.ts'te değil: §12 o dosyayı SAYI/TARİH biçiminin tek kapısı
// olarak tanımlıyor; buradakiler sayı biçimlemiyor (telefon maskesi, cihaz
// sınıfı) ve şimdilik yalnız bu ekranda kullanılıyor. UA ayrıştırması
// tekrarlanmıyor: hepsi trFormat'taki `cihazAdi()`'nın çıktısı üzerinden
// çalışıyor, böylece tarayıcı/işletim listesi tek yerde kalıyor.

import { cihazAdi } from '../../lib/trFormat'

/** `cihazAdi()`'nın üretebildiği tarayıcı adları (trFormat.ts:90-96). */
const TARAYICILAR = ['Edge', 'Opera', 'Chrome', 'Firefox', 'Safari']

/** `cihazAdi()`'nın üretebildiği işletim sistemleri (trFormat.ts:98-104). */
const MOBIL_ISLETIM = ['iOS', 'Android']
const MASAUSTU_ISLETIM = ['Windows', 'macOS', 'Linux']

/**
 * Telefonu sol özet kartı için maskeler: `0532 418 22 18` → `0532 4•• •• 18`
 * (ref 13:511). Hesap Bilgileri formu HAM numarayı göstermeye devam eder —
 * maskeli değer forma yazılsaydı ilk kaydetmede gerçek numara bozulurdu.
 *
 * 11 hane dışındaki biçimlerde numara olduğu gibi gösterilmez; ayırıcılar
 * korunup son iki hane dışındaki rakamlar gizlenir, yani maske hiçbir girdide
 * sessizce devre dışı kalmaz.
 */
export function telMaskesi(tel: string | null | undefined): string {
  if (!tel || !tel.trim()) return '—'

  const rakam = tel.replace(/\D/g, '')
  if (rakam.length === 11)
    return `${rakam.slice(0, 4)} ${rakam[4]}•• •• ${rakam.slice(9)}`

  const gizlenecek = Math.max(rakam.length - 2, 0)
  let sayac = 0
  return tel.replace(/\d/g, (d) => (sayac++ < gizlenecek ? '•' : d))
}

/**
 * Yalnız tarayıcı adı — "Son giriş  Bugün 07:58 · Chrome" satırı (ref 13:513).
 * `cihazAdi()` "Chrome · Windows" üretiyor ve tanımadığı UA'yı kısaltıp olduğu
 * gibi döndürüyor; burada bilinen isimlere süzülüyor, aksi hâlde ham bir metin
 * tarayıcı adı gibi görünürdü (K32: bilinmeyen boş kalır).
 */
export function tarayiciAdi(ua: string | null | undefined): string | null {
  if (!ua) return null
  const ilk = cihazAdi(ua).split(' · ')[0]
  return TARAYICILAR.includes(ilk) ? ilk : null
}

/**
 * Cihaz sınıfı — oturum tablosunun `.cell-sub` alt satırı (ref 13:553-554).
 * İşletim sistemi `cihazAdi()`'nın SON parçasıdır; tanınmadığında "—" döner
 * çünkü masaüstü/mobil ayrımını tahmin etmek yanlış cihaz sonlandırmaya yol
 * açabilir.
 */
export function cihazTuru(ua: string | null | undefined): string {
  if (!ua) return '—'
  const parcalar = cihazAdi(ua).split(' · ')
  const isletim = parcalar[parcalar.length - 1]
  if (MOBIL_ISLETIM.includes(isletim)) return 'Mobil'
  if (MASAUSTU_ISLETIM.includes(isletim)) return 'Masaüstü'
  return '—'
}
